import React from "react";
import ImageComponent from "./ImageComponent";

const RenderUserAvatar = ({user}) => {
  if (user) {
    if (user.imageUrl) {
      return (
        <ImageComponent
          src={user.imageUrl}
          alt="User Avatar"
          className="user-avatar"
        />
      );
    }
    if (user.firstName) {
      const initials = user.firstName[0];
      return (
        <div className="user-avatar user-avatar-placeholder">{initials}</div>
      );
    }
  }
  return <></>;
};

export default RenderUserAvatar;
